<template>
  <div>
    <div class="about">
      <p>
        {{ $t('p1') }}
      </p>
      <p>
        {{ $t('p2') }}
      </p>
      <br />
      <h2>
        {{ $t('h2-brand')
        }}<span style="font-style: italic;">{{ $t('h2-what') }}</span>
      </h2>
      <p>
        {{ $t('p3') }}
      </p>
      <br />
      <h2>{{ $t('Site Developers') }}:</h2>
      <DeveloperInfo
        v-for="(developer, index) in developers"
        :key="`developer_${index}`"
        v-bind="developer"
      />
    </div>
    <footer class="version-footer">{{ appVersion }}</footer>
  </div>
</template>

<script>
import { version } from '../../package.json';
import DeveloperInfo from '@/components/DeveloperInfo.vue';

export default {
  name: 'About',
  components: {
    DeveloperInfo,
  },
  data() {
    return {
      developers: this.genDeveloperInfoObjects(),
      version,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    appVersion() {
      return process.env.VUE_APP_DEPLOY_ENV === 'production'
        ? version
        : `${version}-${process.env.VUE_APP_GIT_HASH}`;
    },
  },
  watch: {
    locale() {
      this.developers = this.genDeveloperInfoObjects();
    },
  },
  methods: {
    genDeveloperInfoObjects() {
      return [
        {
          name: this.$t('michelle_name'),
          country: '🇭🇰',
          joined: this.$t('michelle_joined'),
          pictureUrl: require('@/assets/michelle.jpg'),
          description: this.$t('michelle_description'),
        },
        {
          name: this.$t('laurence_name'),
          country: '🇳🇿',
          joined: this.$t('laurence_joined'),
          pictureUrl: require('@/assets/laurence.jpg'),
          description: this.$t('laurence_description'),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/sass/views/About.scss';
</style>

<i18n>
{
  "en": {
    "p1": "We all love Shibuya, don’t we? There are so many great restaurants near our office. It’s one of the perks working for Hennge. However, we also understand you get choice paralysis (first world problems!) By using the data of past GIP lunches, Gohunter helps you find good food near our office.",
    "p2": "Our mission is to encourage more interactions between employees by making the arrangement of GIP lunches and you daily lunches with coworkers easier and more fun! Found an interesting restaurant in Gohunter that you want to go? Shoot it to your colleague! They probably would want to try too. Tired of convenience store food but don’t know where to go? Let Gohunter choose it for you!",
    "p3": "ゴハンター (Gohunter), is a combination of the words ごはん (meals) and ハンター (hunter).",
    "Site Developers": "Site Developers",
    "h2-brand": "Gohunter... ",
    "h2-what": "What?",
    "laurence_name": "Laurence Armstrong",
    "laurence_joined": "June, 2019",
    "laurence_description": "I don't eat natto, durian, stinky tofu or anything a thousand years old. Stop trying to get me to eat your weird food. Bug reports to Michelle please.",
    "michelle_name": "Michelle Lei",
    "michelle_joined": "November, 2018",
    "michelle_description": "I eat natto, durian, thousand-year-old egg, stinky tofu. Feel free to challenge me with any kind of exotic food you can think of 😉 Lunch invitations are welcome. Bug reports to Laurence please."
  },
  "ja": {
    "p1":"皆んな渋谷好きなんでしょう？オフィス辺りに美味しいレストランがいっぱい！HENNGEで働くのいいところの一つだけど、選択肢がありすぎて決められなくなっちゃう！過去の「GIPランチ」のデータを活用して、「ゴハンター」は近くの美味しいレストランを紹介します。",
    "p2": "GIPランチでも、普段の仲間ランチでも、ゴハンターを使えばアレンジ簡単なので、もっと社員交流しましょう！ゴハンターで見たレストラン行ってみたいと思えば同僚誘っちゃえ！皆んなそう思ってるはず。コンビニ弁当はもううんざりだけどどこにすればいいかわからない時はぜひゴハンターへ！",
    "p3": "ゴハンターは「ご飯」と「ハンター」（借主）のコンビネーションです。",
    "Site Developers": "開発者",
    "h2-brand": "ゴハンター",
    "h2-what": "って何？！",
    "laurence_name": "Laurence Armstrong",
    "laurence_joined": "2019年6月",
    "michelle_name": "Michelle Lei",
    "michelle_joined": "2018年11月"
  }
}
</i18n>
